const FONT_SIZE_RESET = 'FONT_SIZE/RESET';

export default function fontSizeResetAction () {
  return {
    type: FONT_SIZE_RESET,
    payload: {}
  };
}

export { FONT_SIZE_RESET };